// Import React library for creating React components
import React from "react";

// Import custom styles for the Button component from an external CSS file
import "./Button.css";

/**
 * Button component renders a clickable button.
 * @param {string} text - The text displayed on the button.
 * @param {function} onClick - Function to handle button click events.
 * @param {boolean} outlined - Flag to determine if the button should have an outlined style.
 * @returns {JSX.Element} - Button component.
 */
function Button({ text, onClick, outlined }) {
  return (
    // JSX structure for the button
    <div
      className={outlined ? "outlined-btn21" : "btn21"} // Apply the appropriate CSS class based on the 'outlined' prop
      onClick={() => onClick()} // Attach the onClick event handler
    >
      {text} {/* Display the text on the button */}
    </div>
  );
}

// Export the Button component as the default export of the module
export default Button;
